import React from 'react';
import '../css/intro_section.css'


const carousel_fun = function () {
    if (window.$ != undefined && window.$(".carousel").length) {
        // Intro carousel
        let introCarousel = window.$(".carousel");
        let introCarouselIndicators = window.$(".carousel-indicators");
        //let list = introCarousel.find(".carousel-inner").children(".carousel-item");
        // for (let i = 0; i < list.length; i++) {
        //     if (i === 0) {
        //         introCarouselIndicators.append("<li data-target='#introCarousel' data-slide-to='" + i + "' class='active'></li>")
        //     } else {
        //         introCarouselIndicators.append("<li data-target='#introCarousel' data-slide-to='" + i + "'></li>")
        //     }
        //     let src = window.$(list[i]).children('.carousel-background').children('img').attr('src');
        //     window.$(list[i]).css("background-image", "url('" + src +"')");
        //     window.$(list[i]).children('.carousel-background').remove();
        // }

        introCarousel.find(".carousel-inner").children(".carousel-item").each(function (index) {
            (index === 0) ?
                introCarouselIndicators.append("<li data-target='#introCarousel' data-slide-to='" + index + "' class='active'></li>") :
                introCarouselIndicators.append("<li data-target='#introCarousel' data-slide-to='" + index + "'></li>");

            window.$(this).css("background-image", "url('" + window.$(this).children('.carousel-background').children('img').attr('src') + "')");
            window.$(this).children('.carousel-background').remove();
        });

        window.$(".carousel").swipe({
            swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
                if (direction == 'left') window.$(this).carousel('next');
                if (direction == 'right') window.$(this).carousel('prev');
            },
            allowPageScroll: "vertical"
        });
    }
}




class IntroSection extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            img1: "",
            img2: "",
            img3: "",
            images: []
        }
    }

    componentDidMount() {
        if (this.props.context !== undefined && this.props.context !== "") {
            if (this.props.context.home !== undefined && this.props.context.home !== "") {
                if (this.props.context.home.appCarousel !== undefined && this.props.context.home.appCarousel !== "") {
                    if (this.props.context.home.appCarousel.length) {
                        let images = [];
                        // let img1 = "";
                        // let img2 = "";
                        // let img3 = "";
                        this.props.context.home.appCarousel.map((item) => {
                            if (item.carouselItem) {
                                images.push(item.carouselItem)
                            }
                        })

                        // if (this.props.context.home.appCarousel[0] !== undefined && this.props.context.home.appCarousel[0].carouselItem !== undefined) {
                        //     img1 = this.props.context.home.appCarousel[0].carouselItem 
                        // }
                        // if (this.props.context.home.appCarousel[1] !== undefined && this.props.context.home.appCarousel[1].carouselItem !== undefined) {
                        //     img2 = this.props.context.home.appCarousel[1].carouselItem 
                        // }
                        // if (this.props.context.home.appCarousel[2] !== undefined && this.props.context.home.appCarousel[2].carouselItem !== undefined) {
                        //     img3 = this.props.context.home.appCarousel[2].carouselItem 
                        // }

                        this.setState({ images });

                        setTimeout(() => {
                            carousel_fun();
                        }, 1000)
                    }

                }
            }
        }



    }

    render() {

        const { images } = this.state;
        let carousel_items;
        if (images && images.length) {
            carousel_items = images.map((item, index) => {
                if (item) {
                    let className = "carousel-item"
                    if (index === 0) {
                        className = 'carousel-item active'
                    }

                    return <div className={className} key={index}>
                        <div className="carousel-background"><img src={item} alt="" /></div>
                    </div>

                }
            })
        }

        return (
            <div className="introsection-frame">
                <section id="intro" className="index">
                    <div className="intro-container container">
                        <div id="introCarousel" className="carousel slide carousel-fade" data-ride="carousel">
                            <ol className="carousel-indicators"></ol>
                            <div className="carousel-inner" role="listbox">
                                {carousel_items}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}


export default IntroSection


// WEBPACK FOOTER //
// ./src/component/introSection.js